module.exports = __webpack_public_path__ + "static/img/4-7.8d5c4131.png";